import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm500, warm300, cream, textMuted } from './tokens'

type Props = { l: Translation['landing']['historia'] }

export const HistoriaSection: React.FC<Props> = ({ l }) => (
  <section id="historia" className="grid md:grid-cols-2 gap-16 md:gap-24 items-center px-10 md:px-20 py-24" style={{ background: cream }}>
    <div className="relative hidden md:block">
      <div
        className="absolute -top-4 -right-4 text-[3.5rem] font-semibold px-4 py-2 rounded-[2px] leading-none z-10"
        style={{ background: warm300, color: warm900, fontFamily: serif }}
      >
        {l.year}
      </div>
      <img
        src="/apps/ca/img/decor/cal_hist_01.png"
        alt=""
        aria-hidden
        className="w-full aspect-[4/3] object-cover rounded-[2px]"
        style={{ filter: 'sepia(15%) contrast(1.05)' }}
      />
      <div
        className="absolute bottom-6 -left-8 px-6 py-4 max-w-[260px] leading-[1.5] rounded-[2px]"
        style={{ background: warm900, color: cream, fontFamily: serif, fontStyle: 'italic', fontSize: '0.95rem' }}
      >
        {l.caption}
        <cite
          className="block not-italic text-[0.68rem] tracking-[0.12em] uppercase mt-2"
          style={{ fontFamily: "'DM Sans', system-ui, sans-serif", opacity: 0.65 }}
        >
          {l.captionSource}
        </cite>
      </div>
    </div>
    <div>
      <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm500 }}>
        <span className="w-6 h-px inline-block" style={{ background: warm500 }} />
        {l.kicker}
      </p>
      <h2
        className="text-[clamp(2rem,3.5vw,3rem)] font-light leading-[1.15] mb-6"
        style={{ fontFamily: serif, color: warm900 }}
      >
        {l.title}
      </h2>
      {l.body.map((p, i) => (
        <p key={i} className="text-[0.95rem] leading-[1.85] mb-4" style={{ color: textMuted }}>{p}</p>
      ))}
    </div>
  </section>
)
